import { render } from "./ManagerCompanyRecordsEditModal.vue?vue&type=template&id=16f7018b"
import script from "./ManagerCompanyRecordsEditModal.vue?vue&type=script&lang=js"
export * from "./ManagerCompanyRecordsEditModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__